import { render } from "./Grid.vue?vue&type=template&id=9b54a6a2&scoped=true&lang=pug"
import script from "./Grid.vue?vue&type=script&lang=js"
export * from "./Grid.vue?vue&type=script&lang=js"

import "./Grid.vue?vue&type=style&index=0&id=9b54a6a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b54a6a2"]])

export default __exports__